"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ExtensionDialogController;
exports.ParseToNull = ParseToNull;

var _jsBeautify = require("js-beautify");

var _jsBeautify2 = _interopRequireDefault(_jsBeautify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var js_beautify = _jsBeautify2.default.js;

/*@ngInject*/
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ExtensionDialogController($scope, $mdDialog, $translate, isAdd, allExtensions, entityId, entityType, extension, types, attributeService) {

    var vm = this;

    vm.types = types;
    vm.isAdd = isAdd;
    vm.entityType = entityType;
    vm.entityId = entityId;
    vm.allExtensions = allExtensions;

    if (extension) {
        vm.extension = angular.copy(extension);
        editTransformers(vm.extension);
    } else {
        vm.extension = {};
    }

    vm.extensionTypeChange = function () {

        if (vm.extension.type === "HTTP") {
            vm.extension.configuration = {
                "converterConfigurations": []
            };
        }
        if (vm.extension.type === "MQTT") {
            vm.extension.configuration = {
                "brokers": []
            };
        }
        if (vm.extension.type === "OPC UA" || vm.extension.type === "MODBUS") {
            vm.extension.configuration = {
                "servers": []
            };
        }
    };

    vm.cancel = cancel;
    function cancel() {
        $mdDialog.cancel();
    }

    vm.save = save;
    function save() {
        var $errorElement = angular.element('[name=theForm]').find('.ng-invalid');

        if ($errorElement.length) {

            var $mdDialogScroll = angular.element('md-dialog-content').scrollTop();
            var $mdDialogTop = angular.element('md-dialog-content').offset().top;
            var $errorElementTop = angular.element('[name=theForm]').find('.ng-invalid').eq(0).offset().top;

            if ($errorElementTop !== $mdDialogTop) {
                angular.element('md-dialog-content').animate({
                    scrollTop: $mdDialogScroll + ($errorElementTop - $mdDialogTop) - 50
                }, 500);
                $errorElement.eq(0).focus();
            }
        } else {

            if (vm.isAdd) {
                vm.allExtensions.push(vm.extension);
            } else {
                var index = vm.allExtensions.indexOf(extension);
                if (index > -1) {
                    vm.allExtensions[index] = vm.extension;
                }
            }

            $mdDialog.hide();
            saveTransformers();

            var editedValue = angular.toJson(vm.allExtensions);

            attributeService.saveEntityAttributes(vm.entityType, vm.entityId, types.attributesScope.shared.value, [{ key: "configuration", value: editedValue }]).then(function success() {});
        }
    }

    vm.validateId = function () {
        var coincidenceArray = vm.allExtensions.filter(function (ext) {
            return ext.id == vm.extension.id;
        });
        if (coincidenceArray.length) {
            if (!vm.isAdd) {
                if (coincidenceArray[0].id == extension.id) {
                    $scope.theForm.extensionId.$setValidity('uniqueIdValidation', true);
                } else {
                    $scope.theForm.extensionId.$setValidity('uniqueIdValidation', false);
                }
            } else {
                $scope.theForm.extensionId.$setValidity('uniqueIdValidation', false);
            }
        } else {
            $scope.theForm.extensionId.$setValidity('uniqueIdValidation', true);
        }
    };

    function saveTransformers() {
        if (vm.extension.type == types.extensionType.http) {
            var config = vm.extension.configuration.converterConfigurations;
            if (config && config.length > 0) {
                for (var i = 0; i < config.length; i++) {
                    for (var j = 0; j < config[i].converters.length; j++) {
                        for (var k = 0; k < config[i].converters[j].attributes.length; k++) {
                            if (config[i].converters[j].attributes[k].transformerType == "toDouble") {
                                config[i].converters[j].attributes[k].transformer = { type: "intToDouble" };
                            }
                            delete config[i].converters[j].attributes[k].transformerType;
                        }
                        for (var l = 0; l < config[i].converters[j].timeseries.length; l++) {
                            if (config[i].converters[j].timeseries[l].transformerType == "toDouble") {
                                config[i].converters[j].timeseries[l].transformer = { type: "intToDouble" };
                            }
                            delete config[i].converters[j].timeseries[l].transformerType;
                        }
                    }
                }
            }
        }
        if (vm.extension.type == types.extensionType.mqtt) {
            var brokers = vm.extension.configuration.brokers;
            if (brokers && brokers.length > 0) {
                for (var _i = 0; _i < brokers.length; _i++) {
                    if (brokers[_i].mapping && brokers[_i].mapping.length > 0) {
                        for (var _j = 0; _j < brokers[_i].mapping.length; _j++) {
                            if (brokers[_i].mapping[_j].converterType == "json") {
                                delete brokers[_i].mapping[_j].converter.nameExp;
                                delete brokers[_i].mapping[_j].converter.typeExp;
                            }
                            delete brokers[_i].mapping[_j].converterType;
                        }
                    }
                    if (brokers[_i].connectRequests && brokers[_i].connectRequests.length > 0) {
                        for (var _j2 = 0; _j2 < brokers[_i].connectRequests.length; _j2++) {
                            delete brokers[_i].connectRequests[_j2].nameExp;
                        }
                    }
                    if (brokers[_i].disconnectRequests && brokers[_i].disconnectRequests.length > 0) {
                        for (var _j3 = 0; _j3 < brokers[_i].disconnectRequests.length; _j3++) {
                            delete brokers[_i].disconnectRequests[_j3].nameExp;
                        }
                    }
                    if (brokers[_i].attributeRequests && brokers[_i].attributeRequests.length > 0) {
                        for (var _j4 = 0; _j4 < brokers[_i].attributeRequests.length; _j4++) {
                            delete brokers[_i].attributeRequests[_j4].nameExp;
                        }
                        for (var _j5 = 0; _j5 < brokers[_i].attributeRequests.length; _j5++) {
                            delete brokers[_i].attributeRequests[_j5].attrKey;
                        }
                        for (var _j6 = 0; _j6 < brokers[_i].attributeRequests.length; _j6++) {
                            delete brokers[_i].attributeRequests[_j6].requestId;
                        }
                    }
                }
            }
        }
    }

    function editTransformers(extension) {
        if (extension.type == types.extensionType.http) {
            var config = extension.configuration.converterConfigurations;
            for (var i = 0; i < config.length; i++) {
                for (var j = 0; j < config[i].converters.length; j++) {
                    for (var k = 0; k < config[i].converters[j].attributes.length; k++) {
                        if (config[i].converters[j].attributes[k].transformer) {
                            if (config[i].converters[j].attributes[k].transformer.type == "intToDouble") {
                                config[i].converters[j].attributes[k].transformerType = "toDouble";
                            } else {
                                config[i].converters[j].attributes[k].transformerType = "custom";
                                config[i].converters[j].attributes[k].transformer = js_beautify(config[i].converters[j].attributes[k].transformer, { indent_size: 4 });
                            }
                        }
                    }
                    for (var l = 0; l < config[i].converters[j].timeseries.length; l++) {
                        if (config[i].converters[j].timeseries[l].transformer) {
                            if (config[i].converters[j].timeseries[l].transformer.type == "intToDouble") {
                                config[i].converters[j].timeseries[l].transformerType = "toDouble";
                            } else {
                                config[i].converters[j].timeseries[l].transformerType = "custom";
                                config[i].converters[j].timeseries[l].transformer = js_beautify(config[i].converters[j].timeseries[l].transformer, { indent_size: 4 });
                            }
                        }
                    }
                }
            }
        }
        if (extension.type == types.extensionType.mqtt) {
            var brokers = extension.configuration.brokers;
            for (var _i2 = 0; _i2 < brokers.length; _i2++) {
                if (brokers[_i2].mapping && brokers[_i2].mapping.length > 0) {
                    for (var _j7 = 0; _j7 < brokers[_i2].mapping.length; _j7++) {
                        if (brokers[_i2].mapping[_j7].converter.type == "json") {
                            if (brokers[_i2].mapping[_j7].converter.deviceNameTopicExpression) {
                                brokers[_i2].mapping[_j7].converter.nameExp = "deviceNameTopicExpression";
                            } else {
                                brokers[_i2].mapping[_j7].converter.nameExp = "deviceNameJsonExpression";
                            }
                            if (brokers[_i2].mapping[_j7].converter.deviceTypeTopicExpression) {
                                brokers[_i2].mapping[_j7].converter.typeExp = "deviceTypeTopicExpression";
                            } else {
                                brokers[_i2].mapping[_j7].converter.typeExp = "deviceTypeJsonExpression";
                            }
                            brokers[_i2].mapping[_j7].converterType = "json";
                        } else {
                            brokers[_i2].mapping[_j7].converterType = "custom";
                        }
                    }
                }
                if (brokers[_i2].connectRequests && brokers[_i2].connectRequests.length > 0) {
                    for (var _j8 = 0; _j8 < brokers[_i2].connectRequests.length; _j8++) {
                        if (brokers[_i2].connectRequests[_j8].deviceNameTopicExpression) {
                            brokers[_i2].connectRequests[_j8].nameExp = "deviceNameTopicExpression";
                        } else {
                            brokers[_i2].connectRequests[_j8].nameExp = "deviceNameJsonExpression";
                        }
                    }
                }
                if (brokers[_i2].disconnectRequests && brokers[_i2].disconnectRequests.length > 0) {
                    for (var _j9 = 0; _j9 < brokers[_i2].disconnectRequests.length; _j9++) {
                        if (brokers[_i2].disconnectRequests[_j9].deviceNameTopicExpression) {
                            brokers[_i2].disconnectRequests[_j9].nameExp = "deviceNameTopicExpression";
                        } else {
                            brokers[_i2].disconnectRequests[_j9].nameExp = "deviceNameJsonExpression";
                        }
                    }
                }
                if (brokers[_i2].attributeRequests && brokers[_i2].attributeRequests.length > 0) {
                    for (var _j10 = 0; _j10 < brokers[_i2].attributeRequests.length; _j10++) {
                        if (brokers[_i2].attributeRequests[_j10].deviceNameTopicExpression) {
                            brokers[_i2].attributeRequests[_j10].nameExp = "deviceNameTopicExpression";
                        } else {
                            brokers[_i2].attributeRequests[_j10].nameExp = "deviceNameJsonExpression";
                        }
                        if (brokers[_i2].attributeRequests[_j10].attributeKeyTopicExpression) {
                            brokers[_i2].attributeRequests[_j10].attrKey = "attributeKeyTopicExpression";
                        } else {
                            brokers[_i2].attributeRequests[_j10].attrKey = "attributeKeyJsonExpression";
                        }
                        if (brokers[_i2].attributeRequests[_j10].requestIdTopicExpression) {
                            brokers[_i2].attributeRequests[_j10].requestId = "requestIdTopicExpression";
                        } else {
                            brokers[_i2].attributeRequests[_j10].requestId = "requestIdJsonExpression";
                        }
                    }
                }
            }
        }
    }
}

/*@ngInject*/
function ParseToNull() {
    var linker = function linker(scope, elem, attrs, ngModel) {
        ngModel.$parsers.push(function (value) {
            if (value === "") {
                return null;
            }
            return value;
        });
    };
    return {
        restrict: "A",
        link: linker,
        require: "ngModel"
    };
}


// WEBPACK FOOTER //
// ./src/app/extension/extension-dialog.controller.js